const state = () => ({
  myRooms: [],
  loading: false,
  error: null,
});

export default state;
